import styled from 'styled-components'
import { GRID_SPACING } from '../../constants'

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${GRID_SPACING}px;
`
